module.exports = __webpack_public_path__ + "static/media/curTesis.2e4ed0e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curTesis.png
// module id = 795
// module chunks = 0